// Date-only ranges. Reuse a lane only after the previous inclusive range ends.
export function calendarWeekLanes(ranges, first, last) {
  const visible = ranges.filter((range) =>
    range.start <= last && range.end >= first
  )
    .toSorted((a, b) =>
      a.start.localeCompare(b.start) ||
      String(a.key).localeCompare(String(b.key))
    );
  const lanes = [];
  for (const range of visible) {
    let lane = lanes.find((items) => items.at(-1).end < range.start);
    if (!lane) {
      lane = [];
      lanes.push(lane);
    }
    lane.push(range);
  }
  return lanes;
}
